<mat-list-item
    [ngClass]="{'lv-selected-menu-item': menuSeite?.Identifikator === (selectedSeite$ | async),
                'lv-invalid-menu-item': menuSeite?.Identifikator !== (selectedSeite$ | async) &&
                                        menuSeite?.index <= (highestClickedMenuItem$ | async) &&
                                        !menuSeite?.valid}"
    (click)="onClickMenueItem()" [disabled]="isDisabled">
  <div *ngIf="!!uiControlsRequestPending && !!menuItemRequested && menuItemRequested === menuSeite?.Identifikator" class="lv-button-spinner">
    <mat-progress-spinner class="lv-progress-spinner-black" mode="indeterminate" [diameter]="20"></mat-progress-spinner>
  </div>
  <div [ngClass]="{'lv-hide-menuitem-label': !!uiControlsRequestPending && !!menuItemRequested && menuItemRequested === menuSeite?.Identifikator}">
    {{menuSeite?.Titel | lvHyphenationPipe}}
  </div>
</mat-list-item>
